import React, { useEffect } from "react";
import styles from "./Compressify.module.css";

const Compressify = () => {
  useEffect(() => {
    document.title = "Compressify - Compressor de Imagens Online | Fohattech";
  }, []);

  return (
    <section className={styles.pageWrapper}>
      
      {/* LATERAL ADS FUTURO */}
      <aside className={styles.ads}></aside>

      {/* CONTEÚDO CENTRAL */}
      <div className={styles.container}>
        
        {/* SEO + TÍTULO */}
        <header className={styles.header}>
          <h1>Compressor de Imagens Online</h1>
          <p>
            Reduza o tamanho das suas imagens de forma rápida e gratuita.
            Ideal para melhorar o desempenho de sites, economizar espaço e otimizar uploads.
          </p>
        </header>

        {/* TOOL (IFRAME) */}
        <div className={styles.toolBox}>
          <iframe
            src="/embed/compressify/index.html"
            title="Compressify - Compressor de Imagens"
            loading="lazy"
          ></iframe>
        </div>

        {/* EXPLICAÇÃO (IMPORTANTE PRO ADS) */}
        <section className={styles.info}>
          <h2>Como funciona o Compressify?</h2>
          <p>
            O Compressify é uma ferramenta online que permite comprimir imagens
            sem perder qualidade significativa. Basta enviar sua imagem e o sistema
            realiza a otimização automaticamente.
          </p>

          <h3>Vantagens da compressão de imagens:</h3>
          <ul>
            <li>✔ Reduz o tamanho dos arquivos</li>
            <li>✔ Melhora o carregamento de sites</li>
            <li>✔ Economiza armazenamento</li>
            <li>✔ Ideal para desenvolvedores e criadores de conteúdo</li>
          </ul>
        </section>

      </div>

      {/* LATERAL ADS FUTURO */}
      <aside className={styles.ads}></aside>

    </section>
  );
};

export default Compressify;